<template>
  <div class="min-h-screen bg-gray-300 antialiased flex flex-col">
    <AdminNavbar class="fixed w-full z-20" />
    <router-view class="mt-24" />
  </div>
</template>
<script>
import AdminNavbar from '@/components/AdminNavbar.vue';

export default {
  name: 'Admin',
  components: { AdminNavbar },
};
</script>
